import React from 'react';
import { volumes } from '../data/teknik';

// Neutral CSS placeholders, only shown if an image slot in data/teknik.ts is empty.
export function ProductBoxPlaceholder({
  className = ''
}: {
  className?: string;
}) {
  return <div role="img" aria-label="TEKNIKKLAR™ – 6 digitala volymer i teknik för åk 1–9" className={`relative mx-auto w-full max-w-sm ${className}`} data-id="element-263" data-mp="1eth7ru44zxx7">
      <div className="rounded-2xl bg-[#1B2A5E] p-5 text-white shadow-2xl shadow-slate-900/30" data-id="element-264" data-mp="19tl9mbi4f0pk">
        <p className="text-xs font-semibold uppercase tracking-widest text-white/70" data-id="element-265" data-mp="15rho0u1qmfqk">Åk 1–9 · Lgr22</p>
        <p className="mt-1 font-serif text-4xl leading-none tracking-tight" data-id="element-266" data-mp="10x3w51maaqqn">TEKNIKKLAR<span className="align-super text-[0.45em]" data-id="element-267" data-mp="vvwqb83pc1mm">™</span></p>
        <p className="mt-2 text-sm leading-snug text-white/80" data-id="element-268" data-mp="qxmviylw331j">Bygg · El · Programmering</p>
        <div className="mt-5 grid grid-cols-6 gap-1.5" data-id="element-269" data-mp="2q9xqbwazmuoa">
          {volumes.map(v => <div key={v.number} className={`flex h-36 flex-col justify-between rounded-md border-r-4 border-black/10 p-1.5 ${v.spine}`} data-id="element-270" data-mp="2laui62zpo8c3">
              <span className="text-[9px] font-bold opacity-80" data-id="element-271" data-mp="2t5cwspmes099">{v.number.replace('Volym ', 'V')}</span>
            </div>)}
        </div>
        <p className="mt-4 text-center text-sm font-semibold text-[#FECC02]" data-id="element-272" data-mp="2y3ed52sg9lh1">6 volymer + 5 bonusar</p>
      </div>
    </div>;
}
export function PagePlaceholder({
  label,
  title
}: {
  label: string;
  title: string;
}) {
  return <div className="flex h-full w-full flex-col bg-white" aria-hidden="true" data-id="element-273" data-mp="3bwvucgxnym3w">
      <div className="flex items-center justify-between bg-[#1B2A5E] px-4 py-3 text-white" data-id="element-274" data-mp="3byyuhtsj5vmc">
        <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-275" data-mp="3gv72mn8b8ok0">TEKNIKKLAR™</span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5" data-id="element-276" data-mp="324zw95vkuvzo">
        <p className="text-[11px] font-bold uppercase tracking-widest text-[#2BB673]" data-id="element-277" data-mp="375dtdsvn4lix">{label}</p>
        <p className="font-serif text-xl leading-tight text-slate-900" data-id="element-278" data-mp="3uvhv1up9qb7a">{title}</p>
      </div>
    </div>;
}